module.exports = __webpack_public_path__ + "img/fourth-slide-logo.9253bff7.png";